import React from "react";
import { ButtonStatesInterface } from "../../../components/web/propertyDetail/v2Components/PropertyDocumentViewListItem";

interface ButtonStatusTextPropsInterface {
  title: string;
  successTitle?: string;
  failureTitle?: string;
  processingTitle?: string;
  buttonStates: ButtonStatesInterface;
}

export const ButtonStatusText: React.FC<ButtonStatusTextPropsInterface> = ({
  title = "Submit",
  successTitle = "Submitted",
  failureTitle = "Failed",
  processingTitle = "Submitting",
  buttonStates,
}) => {
  return (
    <div className="flex items-center justify-center gap-2 w-full text-center">
      <p className="break-words truncate leading-snug">
        {buttonStates?.processing && processingTitle}
        {!buttonStates?.processing &&
          !buttonStates?.success &&
          !buttonStates?.error &&
          title}
        {buttonStates?.success && successTitle}
        {buttonStates?.error && failureTitle}
      </p>

      <span className="shrink-0">
        {buttonStates?.processing && "..."}
        {buttonStates?.success && "✔️"}
        {buttonStates?.error && "❌"}
      </span>
    </div>
  );
};
